/**
 * To convert seconds into minutes
 * @param {number} seconds 
 * @param {boolean} ignoreSuffix 
 * @returns Minutes in mm.s Min
 */
export const secToMin = (seconds, enableSuffix = false) => {
    const mintutes = seconds / 60;
    if (Math.ceil(mintutes) === mintutes)
        return `${mintutes.toFixed(0)} ${enableSuffix ? 'Min' : ''}`;
    return `${mintutes.toFixed(1)} ${enableSuffix ? 'Min' : ''}`;
}